export interface Plan {
  id: string;
  name: string;
  description: string;
  monthlyPrice: number;
  yearlyPrice: number;
  monthlyPriceId: string;
  yearlyPriceId: string;
  productIds: string[];
  features: string[];
  highlighted?: boolean;
}

export const plans: Plan[] = [
  {
    id: 'basico',
    name: 'Básico',
    description: 'Ideal para começar seus estudos',
    monthlyPrice: 15.00,
    yearlyPrice: 150.00,
    monthlyPriceId: 'price_1SpHUWHMKPTSiTLH6HpJb5Qd',
    yearlyPriceId: 'price_1SpHV4HMKPTSiTLHCtf9c9yN',
    productIds: ['prod_TmrCOqmW4BGSnQ', 'prod_TmrDMcHY6gLsxB'],
    features: [
      'Até 5 disciplinas',
      'Até 50 sessões/mês',
      'Progresso detalhado por disciplina',
      'Timer Pomodoro',
      'Acompanhamento de revisões',
      'Histórico completo',
    ],
  },
  {
    id: 'pro',
    name: 'Pro',
    description: 'Para estudantes dedicados',
    monthlyPrice: 18.00,
    yearlyPrice: 180.00,
    monthlyPriceId: 'price_1SpHVQHMKPTSiTLHYBiPvkr6',
    yearlyPriceId: 'price_1SpHVnHMKPTSiTLHIa9keK1E',
    productIds: ['prod_TmrDQQB0MtOPdL', 'prod_TmrEo4Ltvvq0Lo'],
    features: [
      'Até 20 disciplinas',
      'Sessões ilimitadas',
      'Estatísticas avançadas',
      'Plano de estudos com pesos',
      'Conquistas e badges',
      'Suporte prioritário',
    ],
    highlighted: true,
  },
  {
    id: 'premium',
    name: 'Premium',
    description: 'Experiência completa',
    monthlyPrice: 21.60,
    yearlyPrice: 216.00,
    monthlyPriceId: 'price_1SpHWFHMKPTSiTLHEiSlxOmM',
    yearlyPriceId: 'price_1SpSwJHMKPTSiTLHDSM15iIl',
    productIds: ['prod_TmrEFAajmA8drg', 'prod_Tn32rnf6SwXKkv'],
    features: [
      'Disciplinas ilimitadas',
      'Sessões ilimitadas',
      'Tudo do plano Pro',
      'Recomendação por IA personalizada',
      'Análise semanal de desempenho por IA',
      'Suporte VIP 24/7',
    ],
  },
];

export const getPlanByProductId = (productId: string): Plan | undefined => {
  return plans.find(plan => plan.productIds.includes(productId));
};

export const getPlanByPriceId = (priceId: string): Plan | undefined => {
  return plans.find(plan => 
    plan.monthlyPriceId === priceId || plan.yearlyPriceId === priceId
  );
};
